// extracted by mini-css-extract-plugin
module.exports = {"heading":"ForumModalAskContent_heading__1IBW4","closeButton":"ForumModalAskContent_closeButton__1SbuB","sending":"ForumModalAskContent_sending__38zTp"};